<script>
  import { createEventDispatcher } from "svelte"

  export let disabled = false
  export let padding = false
  export let color = "var(--black)"
  export let backgroundColor = "var(--white)"
  export let borderColor = "var(--black)"

  const dispatch = createEventDispatcher()
  const style = [
    `--color: ${color};`,
    `--background-color: ${backgroundColor};`,
    `--border-color: ${borderColor};`,
  ].join("")

  function onClick() {
    if (disabled) return
    dispatch("click")
  }
</script>

<button on:click={onClick} {disabled} class:padding {style}>
  <slot />
</button>

<style>
  button {
    border: 0;
    padding: 0;
    box-sizing: border-box;
    font-size: inherit;
    line-height: inherit;
    height: calc(var(--line-height-m) * 1.5);
    min-width: calc(var(--line-height-m) * 1.5);
    color: var(--color);
    background-color: var(--background-color);
    border: 1px solid var(--border-color);
    border-radius: 99px;
    white-space: nowrap;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: stretch;
    align-items: center;
    width: max-content;
  }
  .padding {
    padding: 0 0.6em;
  }
  button:focus {
    outline: 0;
  }
  [disabled] {
    cursor: auto;
  }
</style>
